import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMapMarker, MapData } from '../../../model/global';

export type MapInitialState = {
	initialMapData: MapData;
	currentMarker: IMapMarker;
	mapCentre: {
		lat: number;
		lng: number;
	};
	mapZoom: number;
};
const initialState: MapInitialState = {
	initialMapData: {
		settings: {
			defaultCenter: {
				label: 'DGTLS Munich test',
				lat: 48.1214729,
				lng: 11.5482703,
			},
			defaultZoom: 14,
			defaultMarker: undefined,
		},
	},
	currentMarker: {
		label: '',
		lat: -1,
		lng: -1,
	},
	mapCentre: {
		lat: -1,
		lng: -1,
	},
	mapZoom: 12,
};

const mapSlice = createSlice({
	name: 'mapSlice',
	initialState,
	reducers: {
		/** Add the components initial map config to the store data (render by the backend on the component's JSON) */
		initMapInitialData(state, { payload }: PayloadAction<MapData>) {
			state.initialMapData = payload;
		},

		setCurrentMarker(state, { payload }: PayloadAction<MapInitialState['currentMarker']>) {
			state.currentMarker = payload;
		},
		// setMapCentre(state, { payload }: PayloadAction<Pick<IMapMarker, 'lat'|'lng'>>)
		// map centre init should be asigned on initMapData
		setMapCentre(state, { payload }: PayloadAction<MapInitialState['mapCentre']>) {
			state.mapCentre = payload;
		},
		setMapZoom(state, { payload }: PayloadAction<MapInitialState['mapZoom']>) {
			state.mapZoom = payload;
		},
	},
});

export const mapSliceActions = mapSlice.actions;
export default mapSlice.reducer;
